import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

function EditPaymentMethod({ row, open, triggerFetch, closeDialog }) {
  const theme = useTheme();
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [errors, setErrors] = useState({});

  const typeOptions = ["مسبقة الدفع", "دفع فوري", "آجلة الدفع"];

  useEffect(() => {
    if (row) {
      setName(row.name);
      setType(row.type);
    }
  }, [row]);
  const handleSubmit = async () => {
    // Reset errors
    const newErrors = {};

    // Validation checks
    if (!name.trim()) newErrors.name = "الإسم مطلوب.";
    if (!type.trim()) newErrors.type = "النوع مطلوب.";
    // If there are errors, set them and prevent submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const editedMethod = {
      name: name,
      type: type,
    };
    if (row === editedMethod) {
      toast.error("أنت لم تقم بتعديل أي شيء!");
      return;
    }
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/paymentmethod/${row.id}`,
        editedMethod,
        {
          withCredentials: true,
        }
      );
      if (res) {
        closeDialog();
        triggerFetch();
        toast.success("تم تعديل طريقة الدفع بنجاح!");
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          borderRadius: "12px",
          minWidth: "300px",
        },
      }}
    >
      <Box sx={{ padding: "24px 24px 0" }}>
        <Typography variant="h5">تعديل طريقة الدفع</Typography>
      </Box>
      <DialogContent>
        <FormControl fullWidth sx={{ padding: "12px 0" }}>
          <TextField
            fullWidth
            label="إسم طريقة الدفع"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
          />
        </FormControl>
        <FormControl
          fullWidth
          sx={{ flex: "1 1 45%", minWidth: "250px" }}
          error={!!errors.type}
        >
          <InputLabel id="view-type-label">النوع</InputLabel>
          <Select
            fullWidth
            labelId="view-type-label"
            label="النوع"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            {typeOptions.map((type, index) => (
              <MenuItem key={index} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors.type}</FormHelperText>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => closeDialog()}
          variant="text"
          color={theme.palette.neutral[900]}
        >
          إغلاق
        </Button>
        <Button onClick={handleSubmit} variant="contained">
          تعديل
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditPaymentMethod;
